import React from 'react'

export default function BalanceOfPayments() {
  return (
    <div>BalanceOfPayments</div>
  )
}
